import { useQuery } from 'react-query';
import { getCORAData, aftxGetFCCORAData } from 'src/utils/Queries';
import { CORAInput, GetCORADataResponse } from 'src/features/types/coraTypes';
import { useUser } from 'src/utils/UserContext';

export function useCORAData(input?: CORAInput) {
    const { user } = useUser();
    
    return useQuery<GetCORADataResponse, Error>(
        ['cora-data', input],
        async () => {
            if (!input) {
                throw new Error('Input is required');
            }
            
            // Use AFTX API if user is from AFTX domain, otherwise use regular API
            if (user?.isAFTX) {
                return await aftxGetFCCORAData(input);
            } else {
                return await getCORAData(input);
            }
        },
        {
            enabled: !!input && !!input.nodeIds && input.nodeIds.length > 0,
            staleTime: 0,
            cacheTime: 300000, // 5 minutes
            retry: 2,
            refetchOnWindowFocus: false
        }
    );
}
